module.exports = __webpack_public_path__ + "assets/img/2019_3.5b977073.png";